import Box from '@mui/material/Box';

import { CustomFieldProps } from '../../../../../interfaces/CustomFieldProps';
import '../../../../../assets/styles/formattedTextViewer.css';

const DescriptionTextField = ({ field }: CustomFieldProps) => (
  <Box marginBottom='24px'>
    <div
      className='formatted-text-viewer'
      dangerouslySetInnerHTML={{ __html: field.fieldTitle }}
    ></div>
  </Box>
);

export default DescriptionTextField;
